import { SchedulesEnum, SectorsEnum } from '../../enums';

export interface SearchFormSelectValues<T> {
  value: T;
  label: string;
}

export interface SearchFilterFormValues {
  sector?: SearchFormSelectValues<SectorsEnum>;
  searchTerm?: string;
  schedule?: SearchFormSelectValues<SchedulesEnum>;
  postalCode?: SearchFormSelectValues<string>;
}

export enum VacancyFilterMode {
  ALL = 'ALL',
  HQ = 'HQ',
  AGENCY = 'AGENCY',
}

export interface VacanciesSearchFilterProps {
  onSearch: (filterData: SearchFilterFormValues) => void;
  isLoading?: boolean;
  showPostalCode?: boolean;
  filterMode: VacancyFilterMode;
}
